<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col lg="12">
                <b-card>
                    <div slot="header">
                        <strong>Gán người dùng cho nhóm người dùng <i style="text-decoration: underline">{{ role.name }}</i></strong>
                    </div>
                    <b-form @submit.prevent="search">
                        <b-row>
                            <b-col offset-md="3">
                                <b-form-group label="Đơn vị công tác:"
                                              label-for="unit"
                                              label-cols-md="2"
                                              :horizontal="true"
                                              label-align="left">
                                    <unit-tree :cached="true" v-model="searchForm.unitId" ref="unitTree" class="col-md-6" allowTraversal :traversalOption.sync="searchForm.unitTraversalOption"></unit-tree>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col offset-md="3">
                                <b-form-group label="Đơn vị quản lý:"
                                              label-cols-md="2"
                                              :horizontal="true"
                                              label-align="left">
                                    <unit-tree :cached="true" class="col-md-6" v-model="searchForm.manageUnitId"></unit-tree>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col offset-md="3">
                                <b-form-group label="Tên tài khoản:"
                                              label-for="username"
                                              label-cols-md="2"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-form-input type="text" id="username" class="col-md-6"
                                                  placeholder="Nhập tài khoản ..."
                                                  v-model="searchForm.username">
                                    </b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col offset-md="3">
                                <b-form-group label="" :label-cols="4" label-cols-md="2">
                                    <b-button type="submit" variant="primary">Tìm kiếm</b-button>
                                    <b-button type="button" variant="secondary" :to="{ path: '../' }">Quay lại</b-button>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-form>
                    <br />
                    <b-grid :searchForm="searchForm"
                            :gridOptions="gridOptions"
                            :showActions="false"
                            dataUrl="users/list"
                            :onItemDataBound="onItemDataBound"
                            gridName="Danh sách người dùng"
                            ref="userTable">
                        <template v-slot:cell(role)="row">
                            <b-form-checkbox v-model="row.item.checked" @change="assignUserToRole(row.item.id)"></b-form-checkbox>
                        </template>
                    </b-grid>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
    import { mixins } from '@/shared/mixins'

    export default {
        name: 'ListUser',
        mixins: [mixins],
        data() {
            return {
                searchForm: {
                    username: null,
                    unitId: null,
                    unitTraversalOption: 2,
                    manageUnitId: null
                },
                gridOptions: {
                    fields: [
                        { key: 'username', label: 'Tên tài khoản', sortable: true, sortDirection: 'asc' },
                        { key: 'fullName', label: 'Họ tên', sortable: true },
                        { key: 'unitName', label: 'Đơn vị', sortable: true, tdAttr: (key, value, item) => ({ title: item.unitFullName }) },
                        { key: 'phoneNumber', label: 'Số điện thoại', sortable: true },
                        { key: 'role', label: '' }
                    ],
                    sortBy: 'username',
                },
                role: {}
            }
        },
        created() {
            var vm = this;
            this.$services.get(`roles/${this.$route.params.roleId}`).done((role) => {
                vm.role = role;
            });
        },
        methods: {
            search() {
                this.$refs.userTable.refresh();
            },
            assignUserToRole(userId) {
                this.$services.post(`roles/${this.role.id}/assign/${userId}`);
            },
            onItemDataBound(item) {
                item.checked = item.roleIds.indexOf(this.role.id) != -1;
            }
        }
    }
</script>
<style scoped>
</style>
